import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper";

export default function EditionSlider(container) {
  const sliderContainer = container.querySelector(
    ".js-edition-slider-container"
  );
  const nextButtonElement = container.querySelector(".js-edition-slider-next");
  const previousButtonElement = container.querySelector(
    ".js-edition-slider-prev"
  );
  let mobileStretch = Math.ceil(400 - sliderContainer.clientWidth - 40);
  // console.log("mobileStretch", mobileStretch);
  if (mobileStretch > 50) {
    mobileStretch = 50;
  }

  let slider;
  const sliderOptions = {
    init: false,
    loop: true,
    centeredSlides: true,
    effect: "coverflow",
    grabCursor: true,
    spaceBetween: 0,
    slidesOffsetBefore: 0,
    speed: 500,
    slidesPerView: "auto",
    coverflowEffect: {
      rotate: 0,
      slideShadows: false,
      depth: 400,
      stretch: 70,
      modifier: 1
    },
    breakpoints: {
      // when window width is <= 1200px
      440: {
        coverflowEffect: {
          rotate: 0,
          slideShadows: false,
          depth: 400,
          stretch: mobileStretch,
          modifier: 1
        }
      },
      1200: {
        coverflowEffect: {
          rotate: 0,
          slideShadows: false,
          depth: 400,
          stretch: -25,
          modifier: 1
        }
      }
    },
    slideClass: "js-edition-slider-item",
    wrapperClass: "js-edition-slider-wrapper",
    navigation: {
      nextEl: nextButtonElement,
      prevEl: previousButtonElement
    },
    on: {
      init() {
        // console.log("swiper initialized");
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  initSlider();

  function initLazyLoad() {
    const lazyLoad1 = new LazyLoad({
      container,
      elements_selector: ".js-lazy"
    });

    const lazyLoad2 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-bg",
      to_webp: true
    });

    const lazyLoad3 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-webp",
      to_webp: true
    });

    lazyLoad1.loadAll();
    lazyLoad2.loadAll();
    lazyLoad3.loadAll();
  }

  function initSlider() {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }
}
